<div class="a-card">
  <div class="card-content">
    <div class="card-content">
      <div class="card hoverable">
        <div class="heading-1">Label: {{node.label}}</div>
        <div class="heading-1">Type: {{node.type}}</div>
        <div class="heading-1">Children: {{node.children?.length}}</div>
      </div>
    </div>
  </div>
</div>

<ng-template #buttons>
  <button pButton label="Refresh" icon="fa fa-refresh" (click)="refresh()" class="p-button-text"></button>
  <button pButton label="Refresh" icon="fa fa-refresh" (click)="refresh()" class="p-button-text"></button>
  <button pButton label="Delete Node" icon="fa fa-trash" (click)="deleteNode(node)" class="p-button-text">
  </button>
  <button pButton label="Add Node" icon="fa fa-trash" (click)="addNode()" class="p-button-text">
  </button>
</ng-template>
